import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { closeAllModal, showModal } from "../../../features/modal/modalSlice"
import Btn from "../../shared/button/Btn"
import oo from "../../../images/img/oo.png"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${({theme}) => theme.mainTextColor};

     
        .content{
            display: flex;
            flex-direction: column;
            align-items: center;

            .img-kamyonoo{
                width: 80px;
                height: 40px;
                margin-bottom: 20px;
            }

            p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                text-align: center;
                padding: 5px 0;
            }

            .btn-container{
                display: flex;
                justify-content: center;
                margin-top: 30px;
            }
        }
         
    }
`

const AddLoadKayitResponseModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const navigate = useNavigate()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal">
            <div className="content">
                <img src={oo} alt="kamyoon" className="img-kamyonoo" />
                <p>Tebrikler...</p>
                <p>Yük kaydınız başarıyla tamamlanmıştır.</p>
                <div className="btn-container">
                    <Btn bgColor="#E85446" color="#fff" handleClick={()=> {dispatch(closeAllModal()); navigate("/yukler-listesi")}} width={"220px"}>Çıkış</Btn>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default AddLoadKayitResponseModal